import { API_URL } from './comun';

export const SERVICIO_UTILES = {
    tipoGarantias: `${API_URL}comercial/tipos_garantiau`
};
